// extracted by mini-css-extract-plugin
export default {"counter":"ChooseSentencesForm_counter__Nez5C"};